



















































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import { isError } from 'lodash';
import LayoutModule from '~/store/layout';
import PopUpModalComponent from '~/components/PopUpModalComponent.vue';
import PopUpModalComponentPHI from '~/components/PopUpModalComponentPHI.vue';

import EnrollmentModule from '~/store/enrollment';
import FooterModule from '~/store/footer';

@Component<Footer>({
  components: {
    PopUpModalComponent,
    PopUpModalComponentPHI,
  },
})
export default class Footer extends Vue {
  @Resolve
  public layout!: LayoutModule;
  @Resolve
  public enrollment!: EnrollmentModule;
  @Resolve
  public footer!: FooterModule;

  @Prop()
  public brkPoints!: object;
  @Prop({ default: false })
  public isFixed!: boolean;

  get isErrorPage(): boolean {
    return this.$route.path === '/error/'
  }

  get isLandingPage(): boolean {
    return this.$route.path === '/'
  }

  mounted() {
    this.layout.replaceProgramName(this.layout.configuration.programName, this.layout.previousProgramName);
  }

  @Watch('layout.configuration.programName', { deep: true })
  public watchProgramName(programName: string) {
    this.layout.replaceProgramName(programName, this.layout.previousProgramName);
  }

  public get isMyfembreeUploadRoute() {
        return this.$route.path === '/upload-documents' && this.enrollment.currentDrugPath === 'Myfembree';
  }
  public get isOrgovyxUploadRoute() {
    return this.$route.path === '/upload-documents' && this.enrollment.currentDrugPath === 'Orgovyx';
  }

  public get footerInfoLinkLocation() {
    return this.layout.configuration.footerInfoLinkLocation;
  }

  public get isTopOrBottomBar() {
    return ['top', 'bottom'].includes(this.footerInfoLinkLocation);
  }

  public get isLeftOrRightBar() {
    return ['left', 'right'].includes(this.footerInfoLinkLocation);
  }

  public get footerLogoSrc() {
    return this.layout.configuration.images.footer || this.$settings.url(this.$settings.footerLogo);
  }

  public get headerLogoSrc() {
    return this.layout.configuration.images.header || this.$settings.url(this.$settings.headerLogo);
  }
  public get trademarkLogoSrc() {
    return this.$settings.url(this.$settings.trademarkLogo);
  }
}
